<template>
  <ts-card style="height: inherit;" class="ts-flex ts-flex-col">
    <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
      <h4 class="ts-text-sm">{{ $t('user.changePasswordPage') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper class="ts-flex-grow ts-overflow-hidden">
      <form class="ts-overflow-hidden ts-h-full ts-flex ts-flex-col">
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label">{{ $t('user.userName') }}</label>
              <div>
                <ts-input :value="user.user_name" disabled />
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label">{{ $t('user.password') }}</label>
              <div>
                <ts-input
                  type="password"
                  v-model="model.new_password"
                  :class="{ 'is-invalid': errors.has('new_password') }"
                />
                <div class="invalid-feedback" v-if="errors.has('new_password')">{{ errors.first('new_password') }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label">{{ $t('user.passwordConfirmation') }}</label>
              <div>
                <ts-input
                  type="password"
                  v-model="model.new_password_confirmation"
                  :class="{ 'is-invalid': errors.has('new_password_confirmation') }"
                />
                <div class="invalid-feedback" v-if="errors.has('new_password_confirmation')">
                  {{ errors.first('new_password_confirmation') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 text-right">
            <ts-button @click.prevent="$emit('close')" :disabled="saving">{{ $t('button.cancel') }}</ts-button>
            <ts-button color="primary" class="ml-2" :waiting="saving" @click.prevent="save">{{
              $t('button.save')
            }}</ts-button>
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { cloneDeep } from 'lodash'
import { mapState } from 'vuex'

export default {
  name: 'user-form',
  props: ['user'],
  data() {
    const model = {
      new_password: '',
      new_password_confirmation: ''
    }

    return {
      newModel: model,
      model: cloneDeep(model),
      errors: new Errors(),
      saving: false
    }
  },
  methods: {
    save() {
      this.errors = new Errors()
      this.saving = true

      this.$store
        .dispatch('security/user/changePassword', {
          id: this.user.user_id,
          ...this.model
        })
        .then(response => {
          this.saving = false
          this.$toasted.success(response.message)
          this.$emit('close')
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.saving = false
        })
    }
  }
}
</script>
